import Icon from "../../components/icons";
import { useNavigate } from "react-router-dom";
import Bt360Logo from "../../components/icons/logo";

const WORKSPACES = [
  {
    title: "Pro",
    description: "Manage clients, portfolios and wealth reporting.",
    action: "Open Pro",
    icon: "Pro",
    path: "/pro",
    featured: true
  },
  {
    title: "Tax Harvesting",
    description: "Review tax positions and harvesting opportunities.",
    action: "Open Tax Harvesting",
    icon: "Chart",
    path: "/tax-harvesting"
  },
  {
    title: "Estate Mapping",
    description: "Visualize ownership structures and estate relationships.",
    action: "Coming soon",
    icon: "Diagram",
    comingSoon: true
  }
];

const DashboardLanding = () => {
  const navigate = useNavigate();

  return (
    <main
      className="c-workspace-dashboard"
      style={{ background: "#f7f7f7 url('https://bulltick.com/wp-content/uploads/2025/07/fondo-home-sliders-scaled.jpg') center top / cover no-repeat" }}
    >
      <div className="c-workspace-dashboard__content">
        <div className="c-workspace-dashboard__intro">
          <div className="c-workspace-dashboard__brand" aria-label="Bulltick 360">
            <Bt360Logo width="154px" height="62px" color="#FFFFFF" waveColor="#FFAD2F" />
          </div>
          <h1 className="c-workspace-dashboard__title">Choose a workspace</h1>
          <p className="c-workspace-dashboard__subtitle">
            Select the tools you want to use today.
          </p>
        </div>

        <div className="c-workspace-dashboard__grid">
          {WORKSPACES.map((workspace) => (
            <button
              type="button"
              key={workspace.title}
              className={`c-workspace-dashboard__card${workspace.featured ? " is-featured" : ""}`}
              disabled={workspace.comingSoon}
              onClick={() => navigate(workspace.path)}
            >
              <span className="c-workspace-dashboard__icon">
                <Icon name={workspace.icon} width={28} height={28} color="#FFAD2F" />
              </span>
              <span className="c-workspace-dashboard__card-content">
                <span className="c-workspace-dashboard__card-title">{workspace.title}</span>
                <span className="c-workspace-dashboard__card-description">{workspace.description}</span>
              </span>
              <span className="c-workspace-dashboard__action">
                {workspace.action} {!workspace.comingSoon && <span aria-hidden="true">→</span>}
              </span>
            </button>
          ))}
        </div>
      </div>
    </main>
  );
};

export default DashboardLanding;
